import React from 'react';
import styles from './FooterIcons.module.css';
import { FaLinkedinIn } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";

const FooterIcons = () => {
    return(
        <ul className={styles.list}>
            <a 
                href="https://www.linkedin.com/in/andres-frank" 
                target="_blank" rel="noreferrer" 
            >
                <li className={styles.listItem}>
                    <FaLinkedinIn size="1.2em" className={styles.icon} />
                </li>
            </a>
            <a 
                href="https://www.instagram.com/andyfrank/" 
                target="_blank" rel="noreferrer" 
            >
                <li className={styles.listItem}>
                    <RiInstagramFill size="1.25rem" className={styles.icon} />
                </li>
            </a>
            <a 
                href="https://github.com/pruscius" 
                target="_blank" rel="noreferrer" 
            >
                <li className={styles.listItem}>
                    <svg
                        className={styles.gitHubIcon}
                        width="250x"
                        height="20px"
                        viewBox="0 0 400.000000 481.000000"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <g
                            transform="translate(0.000000,481.000000) scale(0.100000,-0.100000)"
                            stroke="none"
                        >
                            <path
                                d="M780 4728 c-75 -234 -77 -453 -5 -660 l25 -70 -63 -68 c-81 -88 -122 -159 -163 -278 
                                -90 -261 -121 -793 -64 -1067 110 -526 525 -870 1178 -975 l72 -12 -25 -30 c-55 -66 -107
                                -211 -128 -362 l-12 -89 -53 -18 c-81 -28 -205 -42 -301 -36 -255 18 -440 132 -596 372 
                                -150 229 -277 313 -485 322 -167 7 -184 -28 -58 -117 112 -78 241 -257 378 -518 41 -79
                                95 -167 129 -208 105 -127 269 -230 437 -275 134 -36 393 -37 532 -2 l22 5 0 -321 0 
                                -321 640 0 640 0 0 584 c0 479 -3 598 -15 663 -25 134 -82 280 -127 329 l-20 22 74 12 
                                c655 106 1070 451 1178 980 49 238 31 718 -35 975 -41 158 -105 277 -202 376 l-54 56
                                16 38 c31 75 57 201 62 305 6 121 -12 247 -54 378 l-27 83 -40 -7 c-174 -29 -374 -176
                                -543 -400 -56 -75 -56 -75 -77 -55 -89 81 -321 129 -676 138 -426 11 -731 -35 -859 
                                -127 l-40 -30 -57 78 c-108 146 -256 277 -391 346 -47 24 -150 56 -178 56 -6 0 -22 
                                -33 -35 -72z"
                            />
                        </g>
                    </svg>
                </li>
            </a>
            <a 
                href="mailto:andi_frank19@hotmail.com"
                target="_blank"
                rel="noreferrer"
            >
                <li className={styles.listItem}>
                    <MdEmail size="1.4rem" className={`${styles.icon} ${styles.mailIcon}`} />
                </li>
            </a>
            <li className={styles.listMsg}>Andres Frank 2022</li>
        </ul>
    )
}

export default FooterIcons